import { createContext } from 'react';
import { ContextValue } from './types';

const ApplicationFormContext = createContext<ContextValue | null>(null);
export default ApplicationFormContext;

export const ApplicationFormProvider = ApplicationFormContext.Provider;
